export const styles = {
  planActionDetailPage: () => ({}),
};
